var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-calendar',{attrs:{"color":_vm.color,"type":"day","start":_vm.date,"first-interval":"6","interval-count":"16","events":_vm.events},scopedSlots:_vm._u([{key:"day-header",fn:function(ref){
var present = ref.present;
return [void 0]}},{key:"interval",fn:function(ref){
var hour = ref.hour;
return [(hour > 6 && hour < 22)?_c('div',{staticClass:"text-center",on:{"click":function($event){return _vm.$emit('calendarClick', hour)}}},[_vm._v("\n      "+_vm._s(hour)+" "),_c('small',[_vm._v("h")])]):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }